import {FilterAndData} from "../../api/filter-list";

/**
 * Filtros sobre propiedades con `fueraDelPanelDeFiltros`: no se ofrecen en el panel porque los pone
 * la propia pantalla, pero el panel tiene que conservarlos al navegar (reconstruye la URL solo con
 * lo suyo) y no contarlos para encender el embudo.
 */
function esFueraDelPanel(filtro: FilterAndData): boolean {
    return !!filtro?.property?.fueraDelPanelDeFiltros;
}

/** Los filtros que sí son del panel (o la búsqueda general) */
export function sinFiltrosFueraDelPanel(filtros: FilterAndData[] | null): FilterAndData[] {
    return (filtros ?? []).filter(f => !esFueraDelPanel(f));
}

/** Los que hay que conservar al navegar, con un id que no choca con los del panel (sin guiones) */
export function filtrosFueraDelPanel(filtros: FilterAndData[] | null): { [id: string]: FilterAndData } {
    const conservados = {};
    (filtros ?? []).filter(esFueraDelPanel).forEach((f, i) => conservados['fuera' + i] = f);
    return conservados;
}
